import { render, staticRenderFns } from "./EstateInfo.vue?vue&type=template&id=677fa58e&scoped=true&"
import script from "./EstateInfo.vue?vue&type=script&lang=js&"
export * from "./EstateInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677fa58e",
  null
  
)

export default component.exports